import { loadConsultantProcessApiConfig } from "@/config/consultant-process-api";
import { loadContactsProcessApiConfig } from "@/config/contacts-process-api";
import { loadContentServiceConfig } from "@/config/content.service";
import { loadFeatureFlagsServiceConfig } from "@/config/feature-flags-service";
import { loadRegionConfig } from "@/config/region";

import { loadAlgoliaConfig } from "./algolia";
import { loadCaptchaKeyConfig } from "./captcha-key";
import { loadConsumerCartServiceConfig } from "./consumer-cart-service";
import { loadGoogleMapsApiConfig } from "./google-maps-api";
import { loadHybrisConfig } from "./hybris";
import { loadIdentityServiceConfig } from "./identity-service";
import { loadLoggerConfig } from "./logger";
import { loadPartyProcessApiConfig } from "./party-process-api";
import { loadPayPalConfig } from "./paypal";
import { loadPowerReviewsConfig } from "./power-reviews";
import { loadProductCatalogApiConfig } from "./product-catalog-api";
import { loadSolrConfig } from "./solr";
import { Config, PcEnvironment } from ".";
import { loadRedisMemoryConfig } from "./redis-memory";
import { loadRedisPubSubConfig } from "@/config/redis-pub-sub";
import { loadQuizConfig } from "./quiz";

let config: Config;

export function getConfig(): Config {
	if (config === undefined) {
		createConfig();
	}
	return config;
}

function loadPcEnvironment(): PcEnvironment {
	if (!process.env) {
		throw new Error("Environment variables are not set.");
	}

	const env = process.env.PC_ENVIRONMENT ?? "local";
	const validEnvs: PcEnvironment[] = ["local", "sandbox", "test", "prod"];
	if (!validEnvs.includes(env as PcEnvironment)) {
		throw new Error("Invalid PC_ENVIRONMENT");
	}

	return env as PcEnvironment;
}

const pcEnvironment: PcEnvironment = loadPcEnvironment();

/**
 * Creates the configuration object based on the current environment.
 * @returns Config object
 */
function createConfig(): Config {
	const region = loadRegionConfig();

	config = {
		pcEnvironment: pcEnvironment,
		appName: process.env.APP_NAME || "consumer-web",
		appVersion: process.env.APP_VERSION || "unknown",
		region: region,
		algolia: loadAlgoliaConfig(),
		identityService: loadIdentityServiceConfig(),
		consumerCartService: loadConsumerCartServiceConfig(),
		hybris: loadHybrisConfig(),
		logger: loadLoggerConfig(),
		contentService: loadContentServiceConfig(),
		featureFlagsService: loadFeatureFlagsServiceConfig(),
		productCatalogApi: loadProductCatalogApiConfig(),
		solr: loadSolrConfig(),
		partyProcessApi: loadPartyProcessApiConfig(),
		consultantProcessApi: loadConsultantProcessApiConfig(),
		contactsProcessApi: loadContactsProcessApiConfig(),
		googleMaps: loadGoogleMapsApiConfig(),
		captcha: loadCaptchaKeyConfig(),
		redisMemoryConfig: loadRedisMemoryConfig(),
		redisPubSubConfig: loadRedisPubSubConfig(),
		quizConfig: loadQuizConfig(),
		powerReviews: loadPowerReviewsConfig(pcEnvironment),
		paypal: loadPayPalConfig()
	};

	return config;
}
